import { Button } from "@fluentui/react-components";
import {
  PanelLeftContract24Regular,
  PanelLeftExpand24Regular,
} from "@fluentui/react-icons";
import React from "react";

import { useAppSideNavOpenState } from "@/components/AppSideNav/providers/AppSideNavOpenStateProvider";

import styles from "./index.module.css";

export const PageHeader: React.FC = () => {
  const { isFullyClosed, isToggleable, toggleFromMenuBtn } =
    useAppSideNavOpenState();
  if (!isToggleable) return null;
  const label = isFullyClosed ? "サイドナビを開く" : "サイドナビを閉じる";

  return (
    <header className={styles.root}>
      <Button
        appearance="subtle"
        icon={
          isFullyClosed ? (
            <PanelLeftExpand24Regular />
          ) : (
            <PanelLeftContract24Regular />
          )
        }
        aria-label={label}
        aria-expanded={!isFullyClosed}
        className={styles.menuBtn}
        onClick={toggleFromMenuBtn}
      />
    </header>
  );
};
